import {ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {BaseFieldComponent} from "../../base/base-field/base-field.component";
import {OptionSourceData} from "../../multi-option/multi-option.config";
import {DynamicFormService} from "../../../dynamic-form/dynamic-form.service";
import {EventDispatcherService} from "../../../events/event-dispatcher.service";
import {ButtonToggleFieldConfig} from "../button-toggle.config";

@Component({
    selector: 'mydocma-button-toggle-field',
    templateUrl: './button-toggle.component.html',
    styleUrls: ['./button-toggle.component.scss']
})
export class ButtonToggleComponent extends BaseFieldComponent<ButtonToggleFieldConfig> {

    public source: Array<Record<string, string | OptionSourceData>> = []
    public sourceKeys: string[] = [];
    public sourceValues: Array<string | OptionSourceData> = [];
    public readonly staticCssClass = 'mydocma-button-toggle';
    public showLabel: boolean;

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);

    }

    ngOnInit() {
        super.ngOnInit();
        this.setSource();
        setTimeout(()=>console.log(this.control.value), 1000);
    }

    public onFieldWrapperUpdated() {
        super.onFieldWrapperUpdated();
        this.setSource();
    }

    public arrayConverter(value) {
        return Object.keys(value);
    }

    public onResize(event) {

        const showLabel = event.contentRect.width <= 500;
        if (showLabel !== this.showLabel) {
            this.showLabel = showLabel;
            this.changeDetectorRef.detectChanges();
        }
    }

    private setSource() {

        this.source = [];
        if (!this.fieldWrapper.config?.buttons) {
            return this.source
        }
        Object.keys(this.fieldWrapper.config.buttons).forEach(key => this.source.push({
            key,
            value: this.fieldWrapper.config.buttons[key],
            class: this.fieldWrapper.config.buttons[key]?.class,
            readonly: this.fieldWrapper.config.buttons[key].readonly as any,
        }));

    }
}
